import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

const CheckoutForm = ({ onSubmit }) => {

    const stripe = useStripe();
    const elements = useElements();
    
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
    
        setIsLoading(true);
    
        // const { error } = await stripe.confirmPayment({
        //     elements,
        //     confirmParams: {
        //         // Make sure to change this to your payment completion page
        //         return_url: "http://localhost:3000/complete",
        //     },
        // });

        // Confirm payment without redirection
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: "http://localhost:3000/complete",
            },
        });
    
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }
    
        setIsLoading(false);  
    };
    
    return (
        <>
            <PaymentElement />
            <button 
                disabled={loading}
                style={{
                    backgroundColor: "#6772e5",
                    color: "#fff",
                    border: "0",
                    borderRadius: "4px",
                    padding: "12px 16px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                    display: "block",
                    width: "100%",
                    marginTop: "12px"
                }}
                onClick={handleSubmit}
            >
                {loading ? "Loading..." : "Pay"}
            </button>
            {error && <div>{error}</div>}
        </>
    );
};

export default CheckoutForm;